import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { get } from 'lodash';

import pluralize from 'rebook/apps/utils/text/pluralize';
import * as AuthorCitationListActions from 'rebook/apps/catalog/actions/AuthorCitationListActions';
import { Author } from 'rebook/apps/catalog/models';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import BookHasNotReviews from 'rebook/apps/books/components/BookHasNotReviews';
import AuthorInformation from 'rebook/apps/base/components/AuthorInformation';
import BookListItemEmpty from 'rebook/apps/books/components/BookListItemEmpty';
import BookCitation from 'rebook/apps/books/components/BookCitation';

import styles from './style.scss';


class AuthorCitationListView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.AuthorCitationListActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.AuthorCitationListActions.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(AuthorCitationListActions.fetchInitialData(match));
  }

  changePage(newPageNumber) {
    window.scrollTo(0, 0);
    this.props.AuthorCitationListActions.fetchAuthorCitationList(newPageNumber);
  }

  render() {
    const { citations, author, pageNumber, lastPageNumber } = this.props.authorCitationList;
    const theAuthor = new Author(author);

    return (
      <div className={classNames('article', 'backgroundContainer', 'themeGrey')}>
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/' },
            { text: get(author, 'cover_name', ''), url: get(author, 'absolute_url', '') },
            { text: 'Цитаты', url: '' },
          ]} />
          {author && (
            <React.Fragment>
              <div className={styles.headerTitle}>
                <h1>Цитаты из книг автора&nbsp;
                  <Link to={theAuthor.getLink()} className="link">
                    {author.cover_name}
                  </Link>
                </h1>
                <div className={styles.headerTitleReviewCount}>
                  {author.reviews_count}&nbsp;{`${pluralize(author.reviews_count, 'цитата', 'цитаты', 'цитат')}`}
                </div>
              </div>
              {author.citations_count === 0
                ? (
                  <BookHasNotReviews>
                   Еще никто не делал цитат из книг автора {author.cover_name}
                  </BookHasNotReviews>
                )
                : (
                  <AuthorInformation
                    count={author.active_book_count}
                    authorLink={theAuthor.getLink()}
                    imageUrl={author.photo}
                    theme="noBackground"
                    name={author.cover_name} />
                )}
            </React.Fragment>
          )}
          <div className={styles.list}>
            {citations === null
              ? [...Array(5)].map((count, key) => (
                <BookListItemEmpty key={key} />
              ))
              : citations.map((citation) => (
                <BookCitation
                  textTitle="Моя цитата"
                  isBookHeader
                  isAuthor
                  citation={citation}
                  key={citation.id} />
              ))
            }
          </div>
          {lastPageNumber > 1 && (
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  return {
    authorCitationList: state.authorCitationList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    AuthorCitationListActions: bindActionCreators(AuthorCitationListActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthorCitationListView);
